import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getPresets(options = {}) {
	return _apiRequestWrap(
		ModulesMap.PRESETS,
		ModulesConfigMap[ModulesMap.PRESETS].GET_PRESETS,
		options
	)
}

function _getMultiplePresets(options = {}) {
	return _apiRequestWrap(
		ModulesMap.PRESETS,
		ModulesConfigMap[ModulesMap.PRESETS].GET_MULTIPLE_PRESETS,
		options
	)
}

function _deletePreset(options = {}) {
	return _apiRequestWrap(
		ModulesMap.PRESETS,
		ModulesConfigMap[ModulesMap.PRESETS].DELETE_PRESET,
		options
	)
}

function _editPreset(options = {}) {
	return _apiRequestWrap(
		ModulesMap.PRESETS,
		ModulesConfigMap[ModulesMap.PRESETS].EDIT_PRESET,
		options
	)
}

function _patchPreset(options = {}) {
	return _apiRequestWrap(
		ModulesMap.PRESETS,
		ModulesConfigMap[ModulesMap.PRESETS].PATCH_PRESET,
		options
	)
}

function _createPreset(options = {}) {
	return _apiRequestWrap(
		ModulesMap.PRESETS,
		ModulesConfigMap[ModulesMap.PRESETS].CREATE_PRESET,
		options
	)
}

function _cloneToCompanyPreset(options = {}) {
	return _apiRequestWrap(
		ModulesMap.PRESETS,
		ModulesConfigMap[ModulesMap.PRESETS].CLONE_TO_COMPANY_PRESET,
		options
	)
}

function _changePresetsOrder(options = {}) {
	return _apiRequestWrap(
		ModulesMap.PRESETS,
		ModulesConfigMap[ModulesMap.PRESETS].CHANGE_PRESETS_ORDER,
		options
	)
}

export default {
	getPresets: _getPresets,
	getMultiplePresets: _getMultiplePresets,
	deletePreset: _deletePreset,
	editPreset: _editPreset,
	patchPreset: _patchPreset,
	createPreset: _createPreset,
	cloneToCompanyPreset: _cloneToCompanyPreset,
	changePresetsOrder: _changePresetsOrder,
}
